import React from "react";


export default function Servicelogined() {
  return (
    <div style={{"margin-top": "4rem"}} className="img">
      <div class="row justify-content-center text-center">
            <div class="col-md-10 col-lg-8">
              <div class="header-section">
              <h2 className="display-6 text-center pp-5 mb-4">Thank <b>You</b></h2>          
              </div>
            </div>
          </div>
     <img src="/assets/2.png" class="img-fluid rounded mx-auto  d-block" alt="Responsive image"></img>
    </div>

  )


}